export default __webpack_public_path__ + "static/media/reanime-circle-name-image-subtitle-transparent-dark-compressed.08af4bbd.png";